import { gql } from '@apollo/client';

import STUDENT_FRAGMENT from '../fragments/student';

const GET_BASE_STUDENT_QUERY = gql`
  query getBaseStudent($id: Int!) {
    entity: student(where: { id: $id }) {
      ...BaseStudent
    }
  }
  ${STUDENT_FRAGMENT}
`;

export default GET_BASE_STUDENT_QUERY;
